// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__1IAL1","label":"Radio_label__3f1tQ","checkMark":"Radio_checkMark__3UVQO","disabled":"Radio_disabled__1ltsf"};